import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subgroup",
  "use": "icon-subgroup-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-subgroup\">\n<rect x=\"5\" y=\"6\" width=\"8\" height=\"6\" rx=\"2\" fill=\"currentColor\" />\n<rect x=\"13\" y=\"13\" width=\"6\" height=\"4\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M9 10V13C9 14.1046 9.89543 15 11 15L14 15\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol